var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23061 0.695312C9.43757 0.695312 12.0403 3.24252 12.0403 6.38104C12.0403 9.51956 9.43757 12.0668 6.23061 12.0668C3.02365 12.0668 0.420898 9.51956 0.420898 6.38104C0.420898 3.24252 3.02365 0.695312 6.23061 0.695312ZM6.23061 10.8033C8.72685 10.8033 10.7493 8.824 10.7493 6.38104C10.7493 3.93744 8.72685 1.95881 6.23061 1.95881C3.73373 1.95881 1.71195 3.93744 1.71195 6.38104C1.71195 8.824 3.73373 10.8033 6.23061 10.8033ZM11.7079 10.8481L13.5341 12.6347L12.6207 13.5286L10.7951 11.7414L11.7079 10.8481Z",
    fill: "#67768E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogSearch);
export default __webpack_public_path__ + "static/media/LogSearch.662e681587c9677de4b8c6bcb5e89b1f.svg";
export { ForwardRef as ReactComponent };